import React from 'react'

import { ReportFilter } from '@driftt/api-types'
import { Div, Span, Strong } from '@driftt/tide-core'

import { HumanizedFilterOperations } from 'api/report/query/types'
import { FilterableEntityType } from 'hooks/useAvailableFilters'
import { IFilterableEntity } from 'hooks/useFilterableEntities'

export const createMultiValueComponent = (
  allFilterableEntities: Record<FilterableEntityType, IFilterableEntity>,
  filter: ReportFilter,
  multiValue: string[]
) => {
  const fullOptionList = allFilterableEntities[
    filter.property
  ].optionList.filter(
    (option) => multiValue && multiValue.includes(JSON.stringify(option.value))
  )
  const fullLength = fullOptionList.length
  const extraFilters = Math.max(fullLength - 2, 0)
  const hasExtraFilters = fullLength > 2

  let optionList = fullOptionList
  if (hasExtraFilters) {
    optionList = fullOptionList.slice(0, 2)
  }

  const finalText = hasExtraFilters ? (
    <span>
      {' '}
      or <Strong>{extraFilters} more</Strong>
    </span>
  ) : (
    ''
  )

  return (
    <Div className="compound-filter-bar--chip">
      <Span className="compound-filter-bar--title">
        {allFilterableEntities[filter.property].property.label}
      </Span>{' '}
      {HumanizedFilterOperations[filter.operation]}{' '}
      {optionList.map((option: any, index: number) => (
        <Span key={`compound-chip-${option.label}`}>
          <Strong>{option.label}</Strong>
          {optionList[index + 1] ? ' or ' : finalText}
        </Span>
      ))}
    </Div>
  )
}

export const filterToComponent = (
  filter: ReportFilter,
  allFilterableEntities: Record<FilterableEntityType, IFilterableEntity>
): any => {
  let valueString = ''
  const singleValue = !Array.isArray(filter.value) && filter.value
  const multiValue =
    (Array.isArray(filter.value) && filter.value) || filter.values
  if (singleValue) {
    const selectedOption = allFilterableEntities[
      filter.property
    ].optionList.find((option) => option.value === singleValue)
    valueString = selectedOption ? selectedOption.label : ''
    return `${allFilterableEntities[filter.property].property.label} ${
      HumanizedFilterOperations[filter.operation]
    } ${valueString}`
  } else if (multiValue) {
    return createMultiValueComponent(
      allFilterableEntities,
      filter,
      multiValue.map((value) => JSON.stringify(value))
    )
  }
}
